import { isGGI, isGFD, isLMH } from "../actions/root_url";
import _ from 'lodash';

export const getKeysMap = (key, keysMapObj) => keysMapObj[key] || key;
export const getSortVal = (key, desc) => {
  if (desc) {
    key = `-${key}`
  }
  return key
}
/**
 * Moves a column to the specified position in the table
 * @param {Array<Object>} columns
 * @param {Object<string: any>} condition
 * @param {Number} position
 * @return {Array<Object>} columns
 */
export const moveColumnToPosition = (columns, condition, position = -1) => {
  const [[key, value]] = Object.entries(condition);
  const index = columns.findIndex(column => column[key] === value);
  if (index !== -1) {
    const [column] = columns.splice(index, 1)
    if (position === -1) {
      columns.push(column);
    } else {
      columns.splice(position, 0, column);
    }
  }
  return columns;
}
const ggiAllCompaniesWhiteList = ['/purchaseOrder', '/salesOrders', '/salesInvoice', '/salesPerformanceReport', '/inventoriesnew','/customerStatementMain', '/customerStatementMain/', ...isGFD && ['/actionLog', '/actionLog/'], ...isLMH && ['/vendorStatementMain', '/vendorStatementMain/']];
export const isAllCompaniesWhiteList = (path) => {
  if(!path || path == null || path == NaN) {
    return false;
  }
  let isInside = false;
  if(isGGI || isGFD) {
    ggiAllCompaniesWhiteList.map(item => {
      if(path.endsWith(item)) {
        isInside = true;
      }
    })
  }
  if(isLMH) {
    if(path.endsWith('/vendorStatementMain') || path.endsWith('/vendorStatementMain/')) {
      isInside = true;
    }
  }
  return isInside;
}

export const isProductPage = (path) => { // is product file
  if(!path || path == null || path == NaN) {
    return false;
  }
  if(path.indexOf('/products/') != -1 && !path.endsWith('/products/categories') && !path.endsWith('/products/groups')) {
    return true;
  }
  return false;
}


function splitStringByLength(str, len) {
  if (str.length <= len) return [str];
  else return [str.substring(0, len)].concat(splitStringByLength(str.substring(len), len));
}
export const wrapLongWord = (text, maxWidth) => {
  let splitArray = splitStringByLength(text, maxWidth);
  if(splitArray.length == 1) {
    return splitArray[0];
  }
  let tx = '';
  splitArray.map((item, index) => {
    if(index == splitArray.length-1) {
      tx += item;
    } else {
      tx += item + '\n';
    }
  });
  return tx;
}

/**
 * compress image
 * @param file
 * @param maxWidth
 * @param maxHeight
 * @param quality
 * @return {Promise<unknown>}
 */
export function compressImage(file, maxWidth, maxHeight, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader(); // 使用 FileReader 读取文件
    reader.readAsDataURL(file);      // 以 DataURL 格式读取&#8203;:contentReference[oaicite:9]{index=9}
    reader.onload = event => {
      const img = new Image();       // 创建 Image 对象&#8203;:contentReference[oaicite:10]{index=10}
      img.src = event.target.result; // 设置 src 为 DataURL&#8203;:contentReference[oaicite:11]{index=11}
      img.onload = () => {
        let { width, height } = img;
        // 计算缩放比例，保持纵横比
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;   // 保持等比缩放&#8203;:contentReference[oaicite:12]{index=12}
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;        // 设置 Canvas 宽度&#8203;:contentReference[oaicite:13]{index=13}
        canvas.height = height;      // 设置 Canvas 高度&#8203;:contentReference[oaicite:14]{index=14}
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height); // 绘制图像&#8203;:contentReference[oaicite:15]{index=15}
        // 导出结果 Blob，jpeg 格式和质量参数
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob);          // 返回压缩后的 Blob&#8203;:contentReference[oaicite:16]{index=16}
          } else {
            reject(new Error('压缩失败'));
          }
        }, 'image/jpeg', quality);  // MIME 类型和质量参数&#8203;:contentReference[oaicite:17]{index=17}
      };
      img.onerror = err => reject(err);
    };
    reader.onerror = error => reject(error);
  });
}

export function fileDownload(blobData, fileName) {
  const a = document.createElement('a');
  a.style = "display: none";
  document.body.appendChild(a);
  const url = window.URL.createObjectURL(blobData);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

/**
 * Compare two arrays with key
 * diffArrays([1, 2], [1, 2, 3]); // => { added: [3], removed: [] }
 * diffArrays([1, 2, 3], [1, 3]); // => { added: [], removed: [2] }
 * @param oldArray
 * @param newArray
 * @return {{added: unknown[], removed: unknown[]}}
 */
export function diffArrays(oldArray, newArray) {
  const added = _.difference(newArray, oldArray);
  const removed = _.difference(oldArray, newArray);
  return {
    added,
    removed
  };
}

/*
 * PARAMS value: number
 * OUTPUT return: string
 *
 * This function turns any number to include commas and have minimum
 * of two decimal places unless it doesn't have and decimal places past
 * the zero place i.e ( 1000  = "1,000" )
 *
 * Example
 *  input: 1234.5
 *  output: "1,234.50"
 *
 * Note: This does not round, This is intentional. Rounding needs to be
 * done differently for different calculations. i.e (1234.567 = "1,234.567")
 *
 */
export const numberFormatter = (value) => {
  if (!value) return '0';
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (parts[1]) {
    parts[1] = (parts[1].length === 1) ? `${parts[1]}0` : parts[1];
  }
  return parts.join('.');
};


/*
 * PARAMS value: number
 * OUTPUT return: string
 *
 * adds commas, makes sure there are 2 decimal places ,and prepends a dollarsign for cash value
 *
 * Example
 *  input: 1234.5
 *  output: "$1,234.50"
 *
 * input: 1
 * output: "$1.00"
 *
 * Note: This does not round, This is intentional. Rounding needs to be
 * done differently for different calculations. i.e (1234.567 = "$1,234.567")
 *
 */
export const cashFormatter = (amount) => {
  if (amount === null || typeof amount === 'undefined' || isNaN(amount)) return '';
  let formattedNumber = `$${numberFormatter(amount)}`;
  if (formattedNumber.indexOf('.') < 0) {
    formattedNumber = `${formattedNumber}.00`;
  }
  return formattedNumber;
};



// WEBPACK FOOTER //
// ./master/jsx/utils/index.js